import storage from './storage';
// Keep a few dictionary references, not a fresh 20 MB IndexedDB clone per tap.
// Snapshot keys remain distinct, so old game scores/admission never change.
const bundles=new Map(),pending=new Map();
export function rememberMeaningDictionary(value,key='dictionary'){
 if(!value?.meanings?.entries)return;
 bundles.delete(key);bundles.set(key,value);
 while(bundles.size>4)bundles.delete(bundles.keys().next().value);
}
export async function readMeaningDictionary(key){
 if(bundles.has(key))return bundles.get(key);
 if(!pending.has(key))pending.set(key,storage.read(key).then(value=>{rememberMeaningDictionary(value,key);return value;}).finally(()=>pending.delete(key)));
 return pending.get(key);
}
